/* eslint-disable */
import { connect } from 'react-redux';
import { List } from 'immutable';

import decorate from '../../utils/decorate';

import { error, finish, request, clear } from '../../modules/bets/actions/query';

import { request as getBonuses } from '../../modules/bonuses/actions/query-bonuses';
import { request as getSports } from '../../modules/sports/actions/get';

import BetSearch from './BetSearch.jsx';
import api from '../../api';
import { prepareBetsRequestQuery } from './BetSearch.helpers';

const STATE_KEY = 'bets-search';

function mapStateToProps(state) {
    const { sports } = state;
    return {
        sports: sports.get('items', List()),
        isFetchingCompSports: [sports.get('state')].includes('IN_PROGRESS'),
        bets: state.bets.get('items'),
        list: state.bets.getIn(['collections', STATE_KEY, 'items']),
        aggregations: state.bets.getIn(['collections', STATE_KEY, 'aggregations']),
        state: state.bets.getIn(['collections', STATE_KEY, 'state']),
        bonusList: state.bonuses.getIn(['bonuses', 'items']),
    };
}

function queryDataForCSV(query) {
    const sortType = query.type === 'settlement' ? '-settledAt' : '-placedAt';

    const queryWithSort = {
        ...query,
        sort: [sortType]
    }

    const q = prepareBetsRequestQuery(queryWithSort);

    return api.post('/bets', q, { cache: true });
}

function mapDispatchToProps(dispatch) {
    return {
        onQueryBetsRequest: (query) => {
            const sortType = query.type === 'settlement' ? '-settledAt' : '-placedAt';

            return dispatch(request(STATE_KEY, Object.assign({}, query, { sort: [sortType] })));
        },
        onQueryDataForCSV: queryDataForCSV,
        getSports: () => dispatch(getSports()),
        onUnmount: () => dispatch(clear(STATE_KEY)),
        onGetBonusTypes: () => dispatch(getBonuses()),
    };
}

export default decorate(connect(mapStateToProps, mapDispatchToProps), BetSearch);
